import type { FactsheetDetails } from '@/features/factsheet/types';
import type { TemplateChartSeries } from '@/shared/types/charts';

type CreateSeriesParam = {
  factsheet: FactsheetDetails;
  symbol: { timeRef: string; periodType: string; period?: string };
  spotAlias: string | undefined;
  includePeriod: boolean;
};

/**
 * Creates a chart series configuration for the factsheet.
 */
export function createChartSeries({
  factsheet,
  symbol,
  spotAlias,
  includePeriod
}: CreateSeriesParam): TemplateChartSeries {
  return {
    settings: { type: 'line' },
    shortTitle:
      spotAlias ??
      `${factsheet.code} ${symbol.timeRef} ${symbol.periodType} ${symbol.period ?? ''}`.trim(),
    symbol: {
      group: 'Prod_Indexes',
      key: {
        Code: factsheet.code,
        PeriodType: symbol.periodType,
        TimeRef: symbol.timeRef,
        Period: includePeriod && symbol.period ? symbol.period : ''
      }
    }
  };
}
